import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckError = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 30q.7 0 1.18-.47.47-.48.47-1.18t-.47-1.18q-.48-.47-1.18-.47t-1.18.47q-.47.48-.47 1.18t.47 1.17Q19.3 30 20 30zm-1.35-7.65h3V9.7h-3v12.65zM20 40q-4.1 0-7.75-1.57-3.65-1.58-6.38-4.3-2.72-2.73-4.3-6.38Q0 24.1 0 19.95q0-4.1 1.58-7.75 1.57-3.65 4.3-6.35 2.72-2.7 6.37-4.28Q15.9 0 20.05 0q4.1 0 7.75 1.57 3.65 1.58 6.35 4.28 2.7 2.7 4.28 6.35Q40 15.85 40 20q0 4.1-1.57 7.75-1.58 3.65-4.28 6.38t-6.35 4.3Q24.15 40 20 40zm.05-3q7.05 0 12-4.97T37 19.95q0-7.05-4.95-12T20 3Q12.95 3 7.97 7.95 3 12.9 3 20q0 7.05 4.97 12.03Q12.95 37 20.05 37zM20 20z",
		fill: "#fff"
	})
});
export default SvgCheckError;
